import axios from 'axios';
import userManager from '../services/oidcUserManager';
import { ElMessage } from "element-plus";


export async function getAccessToken() {
  const user = await userManager.getUser();
  return user?.access_token;
}


export function setupInterceptor() {
    axios.interceptors.request.use(
        async (config) => {
            const token = await getAccessToken();
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }

            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && error.response.status === 403) {
                ElMessage.error("Erro 403: Acesso negado");
            }

            if (error.response && error.response.status >= 500) {
                ElMessage.error("Erro 500: Erro interno do servidor");
            }

            if (error.response && error.response.status === 401) {
                const isAuthenticationRoute = window.location.pathname === '/login'
                    || window.location.pathname === '/auth/callback';
                if (!isAuthenticationRoute) {
                    ElMessage.info("Sessão expirada. Redirecionando para login...");
                    window.location.replace('/login');
                }
            }
            return Promise.reject(error);
        }
    );
}
